import type { UseMutationResult } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { UseMutationClearOptions } from 'shared/types/tanstack-utility-types'
import type { AddCommentRequestType } from 'modules/comments/api/types'
import type { CommentInterface } from 'modules/comments/components/comment/comment.types'
import { CommentsTypeEnum } from 'modules/comments/types'

interface UseAddCommentOptions<T extends CommentsTypeEnum> extends UseMutationClearOptions<
  CommentInterface,
  Error,
  AddCommentRequestType<T>
> {}

export const useAddComment = <T extends CommentsTypeEnum>({
  ...options
}: UseAddCommentOptions<T>): UseMutationResult<
  CommentInterface,
  Error,
  AddCommentRequestType<T>
> => {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.post,
    CommentInterface,
    AddCommentRequestType<T>
  >({
    method: RequestMethodsEnum.post,
  })

  return useMutation({
    mutationFn: (body: AddCommentRequestType<T>) => fetcher(COMMENT_API_PREFIX, body),
    ...options,
  })
}
